import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cm: {
    defaultMessage: 'cm',
    id: 'n1OMyo',
    description: 'dimension-input.centimeters',
  },
  in: {
    defaultMessage: 'in',
    id: 'ESrEok',
    description: 'dimension-input.inches',
  },
});
